import * as html from 'smg/html';

const mainSection = document.querySelector('main');
if (mainSection?.classList.contains('legal')) {
    const headers = mainSection?.querySelectorAll<HTMLHeadingElement>('h2, h3, h4, h5, h6');
    const dropdownMenu = document.querySelector<HTMLUListElement>('#section-dropdown > ul.dropdown-menu');
    headers?.forEach(header => {
        if (!header.id) {
            return;
        }
        if (header.tagName === 'H2') {
            dropdownMenu?.appendChild(html.FromString(
                `<li><h6><a href="#${header.id}" class="dropdown-item">${header.innerText}</a></h6></li>`,
            ));
        } else {
            dropdownMenu?.appendChild(html.FromString(
                `<li><a href="#${header.id}" class="dropdown-item">${header.innerText}</a></li>`,
            ));
        }
    });
}